import React from 'react';

import { IonContent, IonImg, IonPage, useIonRouter } from '@ionic/react';

import Pic_404 from '../../assets/404.webp';
import Button from '../../components/UI/Button';
import './NotFound.scss';

const NotFoundPage: React.FC = () => {
  const { push } = useIonRouter();

  return (
    <IonPage className="not-found-page">
      <IonContent className='ion-padding'>
        <p className="not-found-page__ups">¡Ups!</p>
        <p className="not-found-page__msg">
          Lo sentimos, no encontramos la página a la que se intentó acceder.
        </p>
        <Button onClick={() => push('/tabs/home')}>Regresar a inicio</Button>

        <IonImg src={Pic_404} alt="404" />
      </IonContent>
    </IonPage>
  );
};

export default NotFoundPage;
